import { AdminExamLocationDetailHeader } from '@exam-center/admin-exam-center-location-details';
import { Outlet } from 'react-router-dom';

export default function AdminExamCenterLocationUsage() {
  return (
    <>
      <AdminExamLocationDetailHeader />
      <Outlet />
    </>
  );
}
